import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LoadTop from '../components/LoadTop';
import BackToTop from '../components/BackToTop';
import Home from "./Home";
import Faq from "./Faq";

// Páginas Internas Padrão
import Sobrenos from "../inner/Sobrenos";
import Error from "../inner/Error";
import Portfolio from "../inner/Portfolio";
import Equipe from "../inner/Equipe";
import Contato from '../inner/Contato';

// --- SEÇÃO DE SERVIÇOS (Caminhos Ajustados) ---
import ServicesPage from '../components/service/gbagro'; 
import CreditoEmpresarial from '../inner/CreditoEmpresarial';
import Agro from '../inner/Agro';
import InteligenciaMercado from '../inner/InteligenciaMercado';
import Seguros from '../inner/Seguros';
import CreditoCarbono from '../inner/CreditoCarbono';

function RouterPage() {
    return (
        <Router>
            <LoadTop />
            <Routes>
                {/* Rotas Institucionais */}
                <Route path="/" element={<Home />} />
                <Route path="/Home" element={<Home />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/Sobrenos" element={<Sobrenos />} />
                <Route path="/404" element={<Error />} />
                <Route path="/Portfolio" element={<Portfolio />} />
                <Route path="/Equipe" element={<Equipe />} />
                <Route path="/Contato" element={<Contato />} />

                {/* Rotas de Serviços */}
                <Route path="/servicos" element={<ServicesPage />} />
                <Route path="/servicos/credito-empresarial" element={<CreditoEmpresarial />} />
                <Route path="/servicos/agro" element={<Agro />} />
                <Route path="/servicos/inteligencia-mercado" element={<InteligenciaMercado />} />
                <Route path="/servicos/seguros" element={<Seguros />} />
                <Route path="/servicos/credito-carbono" element={<CreditoCarbono />} />
            </Routes>
            <BackToTop />
        </Router>
    )
}

export default RouterPage;